import SubmissionCurrencyTab from 'components/features/submission-currency-tabs';
import { DEFAULT_CONVERSION_CURRENCY } from 'components/features/submission-details/types';
import ExcelTable from 'components/ui/excel-table';
import {
  ExcelTableColDef,
  ECellValueType,
} from 'components/ui/excel-table/types';
import FormSection from 'components/ui/form-section';
import { ECurrencies } from 'constants/enums';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

type LayerResultDisplayedData = {
  lossType: string;
  previousIncurred100OurLayer: string;
  previousIncurredOurShare: string;
  payments100OurLayer: string;
  paymentsOurShare: string;
  outstanding100OurLayer: string;
  outstandingOurShare: string;
  newIncurred100OurLayer: string;
  newIncurredOurShare: string;
};

const BinderClaimsFinanacialSummary: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string>(
    DEFAULT_CONVERSION_CURRENCY
  );

  const columnDefs = useMemo<
    ExcelTableColDef<LayerResultDisplayedData, string | number>[]
  >(() => {
    const columns: ExcelTableColDef<
      LayerResultDisplayedData,
      string | number
    >[] = [
      {
        field: 'lossType',
        minWidth: 150,
        flex: 1,
        resizable: true,
        editable: false,
      },
      {
        field: 'previousIncurred100OurLayer',
        minWidth: 180,
        flex: 1,
        resizable: true,
        editable: false,
        type: ECellValueType.NUMERIC_COLUMN,
        precision: 0,
      },
      {
        field: 'previousIncurredOurShare',
        minWidth: 180,
        flex: 1,
        resizable: true,
        editable: false,
        type: ECellValueType.NUMERIC_COLUMN,
        precision: 0,
      },
      {
        field: 'payments100OurLayer',
        minWidth: 180,
        flex: 1,
        resizable: true,
        editable: false,
        type: ECellValueType.NUMERIC_COLUMN,
        precision: 0,
      },
      {
        field: 'paymentsOurShare',
        minWidth: 150,
        flex: 1,
        resizable: true,
        editable: false,
        type: ECellValueType.NUMERIC_COLUMN,
        precision: 0,
      },
      {
        field: 'outstanding100OurLayer',
        minWidth: 180,
        flex: 1,
        resizable: true,
        editable: true,
        type: ECellValueType.NUMERIC_COLUMN,
        precision: 0,
      },
      {
        field: 'outstandingOurShare',
        minWidth: 150,
        flex: 1,
        resizable: true,
        editable: false,
        type: ECellValueType.NUMERIC_COLUMN,
        precision: 0,
      },
      {
        field: 'newIncurred100OurLayer',
        minWidth: 180,
        flex: 1,
        resizable: true,
        editable: false,
        type: ECellValueType.NUMERIC_COLUMN,
        precision: 0,
      },
      {
        field: 'newIncurredOurShare',
        minWidth: 150,
        flex: 1,
        resizable: true,
        editable: false,
        type: ECellValueType.NUMERIC_COLUMN,
        precision: 0,
      },
    ];

    return columns.map((c) => ({
      ...c,
      headerName: t(
        `claim.binderClaimsActions.binderClaimsFinancialSummary.${c.field}`
      ),
    }));
  }, [t]);

  return (
    <div>
      <SubmissionCurrencyTab
        originalCurrency={ECurrencies.AUD}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        className="flex justify-end"
      />
      <FormSection
        title={t(
          'claim.binderClaimsActions.binderClaimsFinancialSummary.title'
        )}
        collapsible
      >
        <ExcelTable
          rowKeyColName="id"
          columnDefs={columnDefs}
          data={[]}
          includeAddRow={false}
          includeDeleteCol={false}
          includeIdRow={false}
          containerClassName="rounded-lg"
          detailRowAutoHeight={true}
          pagination={false}
          summaryRowData={[]}
          domLayout="autoHeight"
        />
      </FormSection>
    </div>
  );
};

export default BinderClaimsFinanacialSummary;
